import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { interval, Subscription } from 'rxjs';
import { Geolocation } from '@capacitor/geolocation';
import { UserModel } from '@shared/models/user.model';
import { environment } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private locRefreshSubscription: Subscription = new Subscription();
  public lastLocation: any = null;
  private teleportLocation: any = null;

  constructor(private userModel: UserModel) {
    //this.testEcho();
    this.getRead();

    Preferences.get({ key: 'TELEPORT_LOCATION' }).then((result) => {
      const val = result.value ? JSON.parse(result.value) : null;
      if (val != null) {
        // Garante compatibilidade com dados antigos que não têm o campo address
        if (!val.address) {
          val.address = null;
        }
        console.log('teleportLocation restored from Preferences: ' + JSON.stringify(val));
        this.teleportLocation = val;
      }
    });
  }


  public setTeleportationLocation(lon: number, lat: number, address?: string) {
    this.teleportLocation = { 
      type: 'Point', 
      coordinates: [lon, lat],
      address: address || null
    };

    Preferences.set({ key: 'TELEPORT_LOCATION', value: JSON.stringify(this.teleportLocation) }).then(() => {
      console.log('teleportLocation saved to Preferences');
    });
  }

  public removeTeleportationLocation(userModel: UserModel) {
    this.teleportLocation = null;

    Preferences.remove({ key: 'TELEPORT_LOCATION' }).then(() => {
      console.log('teleportLocation removed from Preferences');
    });

    userModel.usingTeleportation = false;
    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(userModel) }).then(() => {
      console.log('userModel saved to Preferences');
    });
  }

  public getTeleportationLocation(): any {
    return this.teleportLocation;
  }

  public getTeleportationAddress(): string | null {
    return this.teleportLocation?.address || null;
  }

  public resetLocationRefresher() {
    this.unSubscribeLocationRefresher();
    this.subscribeLocationRefresher();
  }

  public unSubscribeLocationRefresher() {
    this.locRefreshSubscription.unsubscribe();
  }

  private lastLocationSet = false;

  // async testEcho() {
  //   const echoResult = await GeolocationExtras.echo({ value: 'Hello World PLUGIN RODANDO BALA' });
  //   console.log('Echo result:', echoResult.value);
  // }
  
  
  


  public async subscribeLocationRefresher() {
    // Função para salvar a última localização padrão
    const setDefaultLocation = async () => {
      if (!this.lastLocationSet) {
        await Preferences.set({ key: 'LAST_LOCATION', value: JSON.stringify(environment.locationDefault) });
        console.log('lastLocation saved to Preferences');
        this.lastLocationSet = true;
      }
    };
  
    // Verifica o status atual das permissões
    if(!Capacitor.isNativePlatform()){
      await setDefaultLocation();
      return;
    }
    let permissions = await Geolocation.checkPermissions();

    // Solicita permissões se ambas forem "denied"
    if (permissions.coarseLocation === 'denied' && permissions.location === 'denied') {
      await setDefaultLocation();
    } else {
      // Solicita coarseLocation se não for "granted" ou "denied"
      if (permissions.coarseLocation !== 'granted' && permissions.coarseLocation !== 'denied') {
        permissions = await Geolocation.requestPermissions({ permissions: ['coarseLocation'] });
        if (permissions.coarseLocation !== 'granted') {
          await setDefaultLocation();
        }
      }
  
      // Solicita location se não for "granted" ou "denied"
      if (permissions.location !== 'granted' && permissions.location !== 'denied') {
        permissions = await Geolocation.requestPermissions({ permissions: ['location'] });
        if (permissions.location !== 'granted') {
          await setDefaultLocation();
        }
      }
    }
  
    // Inicia a atualização da localização se uma das permissões foi concedida
    if (permissions.coarseLocation === 'granted' || permissions.location === 'granted') {
      this.getRead();
      this.locRefreshSubscription = interval(10000).subscribe(() => {
        this.getRead();
      });
    }
  }
  

  private async getRead() {
    try {
      const gpsOptions = {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 360000000,
      };
      const resp = await Geolocation.getCurrentPosition(gpsOptions);
      const lat = resp.coords.latitude;
      const lon = resp.coords.longitude;
      const locationJson = { type: 'Point', coordinates: [lon, lat] };
      this.lastLocation = locationJson;
      console.log('LocationService Storing location object: ' + JSON.stringify(locationJson));
      Preferences.set({ key: 'LAST_LOCATION', value: JSON.stringify(this.lastLocation) }).then(() => {
        console.log('lastLocation saved to Preferences');
      });

      localStorage.setItem('isLocationEnabled', 'true');

      this.storeLocationTouserModel(locationJson);

    } catch (ex) {
      Preferences.set({ key: 'LAST_LOCATION', value: JSON.stringify(environment.locationDefault) }).then(() => {
        console.log('lastLocation saved to Preferences');
      });
      console.log('Error getting location: ', ex);
      localStorage.setItem('isLocationEnabled', 'false');
    }
  }

  private async storeLocationTouserModel(locationJson: any) {
    const userModelJson = await Preferences.get({ key: 'USER_DATA' });
    if (userModelJson && userModelJson.value) {
      this.userModel = JSON.parse(userModelJson.value);
      // Only overwrite location if user is NOT using teleportation
      if (!this.userModel.usingTeleportation) {
        this.userModel.location = locationJson;
        Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
          console.log('userModel saved to Preferences with new location');
        });
      } else {
        console.log('storeLocationTouserModel: User is using teleportation, preserving teleported location');
      }
    }
  }
}
